import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonTranslateModule } from "src/app/shared/utils/common-translate.module";
import { LoginFormModule } from "../login-page/components/login-form/login-form.module";
import { ResetPasswordDialogModule } from "../reset-password-dialog/reset-password-dialog.module";
import { LoginDialogComponent } from "./login-dialog.component";

@NgModule({
  declarations: [LoginDialogComponent],
  providers: [],
  imports: [
    CommonModule,
    CommonTranslateModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    LoginFormModule,
    ResetPasswordDialogModule,
  ],
})
export class LoginDialogModule {}
